import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import {http} from './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from 'vue-cookie'
import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/index.css';
require('babel-polyfill')
window.$ = require('jquery')
window.JQuery = require('jquery')

Vue.config.productionTip = false

Vue.use(VueAxios, http)

Vue.use(Cookies)

http.interceptors.request.use(function (config) {
    config.headers.Authorization = store.state.token
    return config
}, function (error) {
    return Promise.reject(error)
})

new Vue({
    router,
    store,
    watch: {
        $route () {
            if (store.state.token) {
                this.axios.get('/check-session.json', {
                    headers: {
                        'Authorization': store.state.token
                    }
                }).then((response) => {
                    if (response.data) {
                        store.commit('refreshSession', response.data)
                    }
                })
            }
        }
    },
    mounted: function () {
        if (JSON.parse(Cookies.get('c_extra')) != null) {
            var session = JSON.parse(Cookies.get('c_extra'))
            store.commit('refreshSession',session)
        }
        window.onbeforeunload = function () {
            if (JSON.parse(Cookies.get('c_extra')) != null) {
                return 'Do you really want to leave our brilliant application?'
            }
        }
    },
    destroyed: function () {
        // fix for IE 11
        if (!!window.MSInputMethodContext && !!document.documentMode) {
            window.removeEventListener('hashchange', this.hashChangeHandler)
        }
    },
    render: h => h(App)
}).$mount('#app')
